import * as mock from "../mocks/accountAssetTypes.mock.js";

export function listAccountAssetTypes(accountId) {
  return mock.listAccountAssetTypes(accountId);
}

export function createAccountAssetType(accountId, payload) {
  return mock.createAccountAssetType(accountId, payload);
}

export function updateAccountAssetType(accountId, assetTypeId, payload) {
  return mock.updateAccountAssetType(accountId, assetTypeId, payload);
}

export function deleteAccountAssetType(accountId, assetTypeId) {
  return mock.deleteAccountAssetType(accountId, assetTypeId);
}

export { ASSET_COLUMN_TYPES } from "../mocks/accountAssetTypes.mock.js";
